import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import "./Footer.css";

const Footer = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    // Define your API endpoint here
    const apiUrl = "https://portal.virtualtriage.ca/contact_email";

    // Create a FormData object and append the form data to it
    const formData = new FormData();

    formData.append("email", email);
    formData.append("type", "news");

    // Send a POST request with the FormData
    axios
      .post(apiUrl, formData)
      .then((response) => {
        // Handle a successful response here (e.g., show a success message)
        console.log("Form submitted successfully", response);
        Swal.fire({
          icon: "success",
          title: "Form Submitted!",
          text: "Your form has been submitted successfully.",
        });
        // You can display a success message or redirect the user
      })
      .catch((error) => {
        // Handle any errors here (e.g., show an error message)
        console.error("Error submitting form", error);
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "An error occurred while submitting the form.",
        });
      });
  };

  return (
    <>
      <div
        id="contact-area"
        className="contact-area pt-20"
        style={{ background: "black", borderBottom: "solid" }}
      >
        <div className="container pb-30">
          {/* <!-- Section Title --> */}
          <div className="hero-slide-content heromobifooter">
            <div className="row">
              <div className="col-md-3">
                <h3
                  className="mb-gap fotercentermobi"
                  style={{
                    color: "white",
                    textDecoration: "auto",
                    textAlign: "left",
                    fontFamily: "sans-serif",
                  }}
                >
                  FEATURES
                </h3>
                <div className="fotercentermobi" style={{ textAlign: "start" }}>
                  <Link
                    style={{
                      color: "gray",
                      textDecoration: "auto",
                      textAlign: "center",
                      fontFamily: "sans-serif",
                    }}
                  >
                    Importable Legal History
                  </Link>
                  <br />
                  <Link
                    to="#"
                    style={{ color: "gray", textDecoration: "auto" }}
                  >
                    Remote Case Monitoring
                  </Link>
                  <br />
                  <Link
                    to="#"
                    style={{ color: "gray", textDecoration: "auto" }}
                  >
                    In-App Communication
                  </Link>
                  <br />
                  <Link
                    to="#"
                    style={{ color: "gray", textDecoration: "auto" }}
                  >
                    Real-time Consultation
                  </Link>
                  <br />
                  <Link
                    to="#"
                    style={{ color: "gray", textDecoration: "auto" }}
                  >
                    Video Conference
                  </Link>
                  <br />
                  <Link
                    to="#"
                    style={{ color: "gray", textDecoration: "auto" }}
                  >
                    E-Legal Documentation
                  </Link>
                  <br />
                  <Link
                    to="#"
                    style={{ color: "gray", textDecoration: "auto" }}
                  >
                    AI Chatbot
                  </Link>
                </div>
              </div>
              <div className="col-md-3">
                <h3
                  className="mb-gap fotercentermobi"
                  style={{
                    color: "white",
                    textDecoration: "auto",
                    textAlign: "left",
                    fontFamily: "sans-serif",
                  }}
                >
                  LEGAL EXPERTISE
                </h3>
                <div className="fotercentermobi" style={{ textAlign: "start" }}>
                  <Link
                    to="#"
                    style={{ color: "gray", textDecoration: "auto" }}
                  >
                    Family Law
                  </Link>
                  <br />
                  <Link
                    to="#"
                    style={{ color: "gray", textDecoration: "auto" }}
                  >
                    Real Estate
                  </Link>
                  <br />
                  <Link
                    to="#"
                    style={{ color: "gray", textDecoration: "auto" }}
                  >
                    Corporate Law
                  </Link>
                  <br />
                  <Link
                    to="#"
                    style={{ color: "gray", textDecoration: "auto" }}
                  >
                   Intellectual Property
                  </Link>
                  <br />
                  <Link
                    to="#"
                    style={{ color: "gray", textDecoration: "auto" }}
                  >
                    Criminal Defense
                  </Link>
                  <br />
                  <Link
                    to="#"
                    style={{ color: "gray", textDecoration: "auto" }}
                  >
                    Estate Planning
                  </Link>
                </div>
              </div>
              <div className="col-md-3">
                <h3
                  className="mb-gap fotercentermobi"
                  style={{
                    color: "white",
                    textDecoration: "auto",
                    textAlign: "left",
                    fontFamily: "sans-serif",
                  }}
                >
                  COMPANY
                </h3>
                <div
                  className="fotercentermobi"
                  style={{ textAlign: "start", fontFamily: "sans-serif" }}
                >
                  <Link
                    to="https://portal.lawfully.ai/lawyer_register"
                    style={{ color: "gray", textDecoration: "auto" }}
                  >
                    Become a Legal Advisor
                  </Link>
                  <br />
                  <Link
                    to="#"
                    style={{ color: "gray", textDecoration: "auto" }}
                  >
                    Newsletter
                  </Link>
                  <br />
                  <Link
                    to="/Privacypolicy"
                    style={{ color: "gray", textDecoration: "auto" }}
                  >
                    Privacy Policy
                  </Link>
                  <br />
                  <Link
                    to="#"
                    style={{ color: "gray", textDecoration: "auto" }}
                  >
                    About Us
                  </Link>
                  <br />
                  <Link
                    to="#"
                    style={{ color: "gray", textDecoration: "auto" }}
                  >
                    Careers
                  </Link>
                  <br />
                  <Link
                    to="#"
                    style={{ color: "gray", textDecoration: "auto" }}
                  >
                    Security
                  </Link>
                  <br />
                  <Link
                    to="#"
                    style={{ color: "gray", textDecoration: "auto" }}
                  >
                    Partner
                  </Link>
                </div>
              </div>
              <div className="col-md-3">
                <h3
                  className="mb-gap fotercentermobi"
                  style={{
                    color: "white",
                    textDecoration: "auto",
                    textAlign: "left",
                    fontFamily: "sans-serif",
                  }}
                >
                  SERVICES
                </h3>
                <div className="fotercentermobi" style={{ textAlign: "start" }}>
                  <Link
                    to="#"
                    style={{ color: "gray", textDecoration: "auto" }}
                  >
                    Legal Consultations
                  </Link>
                  <br />
                  <Link
                    to="#"
                    style={{ color: "gray", textDecoration: "auto" }}
                  >
                    Document Processing
                  </Link>
                  <br />
                  <Link
                    to="#"
                    style={{ color: "gray", textDecoration: "auto" }}
                  >
                    Meet our Attorneys
                  </Link>
                  <br />
                  <Link
                    to="#"
                    style={{ color: "gray", textDecoration: "auto" }}
                  >
                    How it works
                  </Link>
                  <br />
                  <Link
                    to="#"
                    style={{ color: "gray", textDecoration: "auto" }}
                  >
                    Contact Us
                  </Link>
                  <br />
                  <Link
                    to="#"
                    style={{ color: "gray", textDecoration: "auto" }}
                  >
                    Pricing
                  </Link>
                  <br />
                  <Link
                    to="#"
                    style={{ color: "gray", textDecoration: "auto" }}
                  >
                    Law Firms
                  </Link>
                </div>
              </div>
            </div>
            <br />
            <br />
            <br />
            <h4
              className="fotertxtsubsmobi"
              style={{
                fontSize: "23px",
                color: "white",
                fontFamily: "sans-serif",
                textAlign:"left"
              }}
            >
              Subscribe for our Newsletter
            </h4>
            <div className="row">
              <div className="col-md-4">
                <form method="post" onSubmit={handleSubmit}>
                  <h6 style={{ color: "gray", fontFamily: "sans-serif",textAlign:"left" }}>
                    Email Address*
                  </h6>
                  <div className="input-group mb-3">
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      placeholder="Enter Email"
                      style={{
                        background: "black",
                        color: "white",
                        height: "38px",
                      }}
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                    <div className="input-group-append">
                      <button
                        className="btn btn-success"
                        type="submit"
                        style={{
                          border: "solid 1px white",
                          height: "38px",
                          color: "white",
                          background: "black",
                        }}
                      >
                        Send
                      </button>
                    </div>
                  </div>
                </form>
              </div>

              <div className="dpmobifoter">
                <div className="col-md-2" style={{ marginTop: "12px" }}>
                  <Link
                    to={
                      "https://apps.apple.com/pk/app/virtual-triage/id1644720170"
                    }
                  >
                    <img
                      alt="baner1"
                      src="/assest/images/FooterImg/App.png"
                      style={{
                        border: "solid 1px white",
                        borderRadius: "10px",
                      }}
                      // data-aos="flip-left"
                      className="foterimgmobi"
                    />
                  </Link>
                </div>
                <div className="col-md-2" style={{ marginTop: "12px" }}>
                  <Link
                    to={
                      "https://play.google.com/store/apps/details?id=com.earcanada"
                    }
                  >
                    <img
                      alt="baner2"
                      src="/assest/images/FooterImg/google.png"
                      style={{
                        border: "solid 1px white",
                        borderRadius: "10px",
                      }}
                      // data-aos="flip-left"
                      className="foterimgmobi"
                    />
                  </Link>
                </div>
                <div className="col-md-2" style={{ marginTop: "12px" }}>
                  <Link to={"https://portal.lawfully.ai/login"}>
                    <img
                      alt="baner"
                      src="/assest/images/FooterImg/web.png"
                      style={{
                        border: "solid 1px white",
                        borderRadius: "10px",
                      }}
                      className="foterimgmobi"
                    />
                  </Link>
                </div>
              </div>
              <div className="col-md-2"></div>
            </div>
          </div>
        </div>

        <div style={{ backgroundColor: "black", borderTop: "solid" }}>
          <div className="container">
            <div
              className="row iconinline"
              style={{ justifyContent: "center", flexDirection: "row" }}
            >
              <div className="mbrow">
                <div
                  className="col-md-5 col3mobi"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <img
                    alt="baner"
                    src="/assest/images/FooterImg/phone.png"
                    style={{ height: "25px", margin: "10px" }}
                    className="fotericonmob"
                  />
                  <h5
                    className="fotertextmob"
                    style={{ fontFamily: "sans-serif" }}
                  >
                    <b
                      style={{ fontSize: "20px", color: "white" }}
                      className="textfotermobi"
                    >
                      <a href="tel:+16476606700">+1 (647) 660 6700</a>
                    </b>
                  </h5>
                </div>

                <div className="col-md-3" style={{ display: "flex" }}>
                  <img
                    alt="baner"
                    src="/assest/images/FooterImg/envolape.png"
                    style={{ height: "25px", margin: "10px" }}
                    className="fotericonmob"
                  />
                  <h5
                    style={{
                      marginTop: "10px",
                      fontSize: "15px",
                      fontFamily: "sans-serif",
                    }}
                    className="fotertextmob"
                  >
                    <b
                      style={{ fontSize: "20px", color: "white" }}
                      className="textfotermobi"
                    >
                      <a href="mailto:info@lawfully.ai">
                        info@lawfully.ai
                      </a>
                    </b>
                  </h5>
                </div>
              </div>
              <div className="col-md-1"></div>

              <div className="col-md-3" style={{ display: "flex" }}>
                <Link to={"https://www.instagram.com/virtual_triage/"}>
                  <img
                    alt="baner"
                    src="/assest/images/FooterImg/intgram.png"
                    style={{
                      height: "35px",
                      border: "solid 2px white",
                      borderRadius: "10px",
                      padding: "5px",
                      margin: "5px",
                    }}
                  />
                </Link>
                <Link
                  to={
                    "https://www.tiktok.com/@virtualtriage?_t=8b0F8fMrecQ&_r=1"
                  }
                >
                  <img
                    alt="baner"
                    src="/assest/images/FooterImg/Tiktok.png"
                    style={{
                      height: "35px",
                      border: "solid 2px white",
                      borderRadius: "10px",
                      padding: "5px",
                      margin: "5px",
                    }}
                  />
                </Link>
                <Link to={"https://pin.it/60RxxzP"}>
                  <img
                    alt="baner"
                    src="/assest/images/FooterImg/pinterest.png"
                    style={{
                      height: "35px",
                      border: "solid 2px white",
                      borderRadius: "10px",
                      padding: "5px",
                      margin: "5px",
                    }}
                  />
                </Link>
                <Link
                  to={"https://www.facebook.com/virtualtriage?mibextid=ZbWKwL"}
                >
                  <img
                    alt="baner"
                    src="/assest/images/FooterImg/fb.png"
                    style={{
                      height: "35px",
                      border: "solid 2px white",
                      borderRadius: "10px",
                      padding: "5px",
                      margin: "5px",
                    }}
                  />
                </Link>
                <Link to={"https://twitter.com/virtual_triage"}>
                  <img
                    alt="baner"
                    src="/assest/images/FooterImg/twitter.png"
                    style={{
                      height: "35px",
                      border: "solid 2px white",
                      borderRadius: "10px",
                      padding: "5px",
                      margin: "5px",
                    }}
                  />
                </Link>
                <Link to={"https://www.linkedin.com/company/virtualtriage/"}>
                  <img
                    alt="baner"
                    src="/assest/images/FooterImg/linkedin.png"
                    style={{
                      height: "35px",
                      border: "solid 2px white",
                      borderRadius: "10px",
                      padding: "5px",
                      margin: "5px",
                    }}
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
